import "./_streamer-modules.scss"

export default class Streamer {
  constructor(elem) {
    const self = this
    self.elem = elem
    return self
  }
}
